import { Modal } from 'react-async-popup';
import '../ui/emergencyPopup.css';
import CloseAuctionsModal from './closeAuctionsModal';

const useCloseAuctionsModal = (ticket, type) => {
  // open modal
  const closeAuctions = async () => {
    const { show } = await Modal.new({
      content: <CloseAuctionsModal ticket={ticket} type={type} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  const openCloseAuctionsModal = async () => {
    return await closeAuctions();
  };

  return {
    openCloseAuctionsModal,
  };
};

export default useCloseAuctionsModal;
